import { request, authRequest } from "~/utils/api";
import { showAppMessage } from "~/redux/actions/app";

export const fetchIosVersionsData = (params) => {
  return request({
    url: "/ios_versions",
    params: params,
  }).then((res) => {
    const { ios_versions, pager } = res.data;
    return { ios_versions, pager };
  });
};

export const fetchIosVersion = (id) => {
  return request({
    url: `/ios_versions/${id}`,
  }).then((res) => {
    return res.data.ios_version;
  });
};

export const createIosVersion = (token, data, callback) => {
  return (dispatch) => {
    return authRequest(token, {
      url: "/ios_versions",
      method: "POST",
      data: data,
    }).then((res) => {
      dispatch(showAppMessage("创建成功", "success"));
      callback();
      return res.data;
    });
  };
};

export const SET_IOS_VERSIONS = "SET_IOS_VERSIONS";
export const fetchIosVersions = (token, page) => {
  return (dispatch) => {
    return authRequest(token, {
      url: "/ios_versions",
      params: { page },
    }).then((res) => {
      dispatch({
        type: SET_IOS_VERSIONS,
        iosVersions: res.data,
      });
    });
  };
};

export const updateIosVersion = (token, params, callback) => {
  return (dispatch) => {
    authRequest(token, {
      url: `/ios_versions/${params.id}`,
      method: "PUT",
      data: {
        ios_version: {
          version: params.version,
          build_number: params.build_number,
          raw_release_note: params.raw_release_note,
          release_note: params.release_note,
          force_update: params.force_update,
          disabled: params.disabled,
        },
      },
    }).then((res) => {
      dispatch(showAppMessage("保存成功", "success"));
      callback();
      return res.data;
    });
  };
};

export const SET_IOS_VERSION_PARAMS = "SET_IOS_VERSION_PARAMS";
export const setIosVersionModalParams = (iosVersionModalParams) => {
  return {
    type: SET_IOS_VERSION_PARAMS,
    iosVersionModalParams,
  };
};
